import Load from 'components/Load';
import React from 'react';
import { Route } from 'react-router-dom';
import { RouteDescriptor, createRouteHandle } from 'routing/types';
import basePath from 'utils/basePath';

import { hostPayoutInternalDescriptors } from './containers/Payout/routes';

const AsyncPayoutContainer = Load(
  () =>
    import(/* webpackChunkName: "host-payout-methods" */ './containers/Payout'),
);

export const hostPayoutRoute: RouteDescriptor = {
  id: 'host.payout',
  path: `${basePath}/host/payout/*`,
  label: 'Host Payout Methods',
  audience: 'host',
  layout: 'standalone',
  module: 'host-payout-methods',
};

export const hostPayoutRoutes = [
  <Route
    key={hostPayoutRoute.id}
    id={hostPayoutRoute.id}
    path={hostPayoutRoute.path}
    handle={createRouteHandle(hostPayoutRoute)}
    element={<AsyncPayoutContainer />}
  />,
];

export const hostPayoutRouteDescriptors = [
  hostPayoutRoute,
  ...hostPayoutInternalDescriptors,
];

export default hostPayoutRoutes;
